import React, { useEffect, useState } from 'react';
import './style.modules.css';
import logo from '../../assets/img/Sobr.png';
import Navbar from '../../components/navbar';
import vector6 from '../../assets/img/Vector6.png';
import arrow from '../../assets/img/arrow.svg';
import midias from '../../assets/img/Social Media.svg';
import africangirl from '../../assets/teamsobr/africangirl.png'
import vector13 from '../../assets/teamsobr/vector13.svg'
import vector14 from '../../assets/teamsobr/vector14.svg'
import couple2 from '../../assets/teamsobr/couple2.png'
import { useNavigate } from 'react-router-dom';
import malte from '../../assets/img/maltefoto.jpg'
import ricardo from '../../assets/img/ricardofoto.jpg'
import koch from '../../assets/img/kochfoto.jpg'
import digao from '../../assets/img/digaofoto.jpg'
import felipe from '../../assets/img/felipefoto.jpg'
import erico from '../../assets/img/erikofoto.jpg'
function TeamSobr() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        // Limpar o listener quando o componente desmontar
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);  
    // Função para rolar até o menu principal
    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo'); // Seleciona o primeiro elemento com a classe 'logo'
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return(
<>
        < Navbar/>    
    <div className="logo">
        <img src={logo} height="36" width="78" alt="logo" title="logo"/>
    </div>
        <img className="shade" src={vector13} alt="shade" title="shade"/>
        <img className="couple2" src={couple2} alt="couple" title="couple" height="400px" width="350px"/>
    <div className='couple-border'></div>
    <div className="content6">
    <h1>Bem-vindo à Sobr, onde a jornada para a felicidade é vibrante e encorajadora.</h1>
    <p> Somos muito mais do que um aplicativo de relacionamento - somos uma comunidade dedicada a redefinir o conceito de felicidade, colocando a sobriedade no centro de tudo que fazemos.
    </p> 
    </div>
    <div className="container10">
    <div className="background">
        <img src={vector14} alt="Background" />
    </div>
    <div className="overlay">
        <img src={africangirl} alt="Girl" className="girl"height="400px" width="350px" />
    </div>
    </div>
        <div className="content6">
        <p>Na Sobr, acreditamos que a verdadeira felicidade não é apenas possível, mas alcançável para todos. Nossa missão é proporcionar um espaço acolhedor e empoderador para aqueles que optam por viver uma vida sóbria, celebrando cada momento de alegria, cada conquista e cada passo em direção ao crescimento pessoal.</p>
        <p>Nosso compromisso com a autenticidade, saúde e relacionamentos sóbrios genuínos é o que nos impulsiona a cada dia. Aqui, você encontrará uma comunidade vibrante de pessoas com mentalidade semelhante, prontas para se apoiarem, se inspirarem e se capacitarem mutuamente em suas jornadas de sobriedade.        </p>
        <p>Então, se você está pronto para embarcar em uma jornada de autoconhecimento, conexão significativa e alegria autêntica, você veio ao lugar certo. Junte-se a nós na Sobr e vamos revolucionar a felicidade juntos.</p>
    </div>
    
    <div className="content7">
        <h1>Seja bem-vindo à nossa comunidade. Seja bem-vindo à Sobr.</h1>
    </div>
{/*     <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
    <div className="verified">
        <span>Verified by</span>
    </div>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
        <div className="verified">
            <span>Verified by</span>
        </div>
        </div>  
        <div className="review-box">
            <div className="header">
                <h3>Margie V.</h3>
                <p>Montevideo</p>
        </div>
        <div className="starx">
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="time">2 months ago</span>
        </div>
            <div className="content">
                <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
            </div>
            <div className="verified">
                <span>Verified by</span>
            </div> 
            </div> */}

<div className="team-container">
    
<div className="team-cardx">
        <div className="profile-image-container">
          <img src={digao} alt="Rodrigo" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Rodrigo Oliveira</h2>
          <h3 className="team-title">Co-Fundador e Diretor Comercial</h3>
          <p className="team-description">
          Já atuou em empresas como Panasonic do Brasil, Stanley’s Care, entre outras...
          </p>
        </div>
      </div>

      <div className="team-cardx">
        <div className="profile-image-container">
          <img src={felipe} alt="Felipe" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Felipe Alarcon</h2>
          <h3 className="team-title">Co-Fundador e CEO</h3>
          <p className="team-description">
          Já foi gerente de operações da BITNATION, ganhadora do Gran Prix da UNESCO e gerente de produtos da CryptoMarket.
          </p>
        </div>
      </div>

      <div className="team-cardx">
        <div className="profile-image-container">
          <img src={koch} alt="Koch" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Marcus Koch</h2>
          <h3 className="team-title">CMO</h3>
          <p className="team-description">
            Contribuiu para marcas como Petrobras, Ponto Frio, Grupo Pão de Açúcar entre outras.
          </p>
        </div>
      </div>
      <div className="team-cardx">
        <div className="profile-image-container">
          <img src={erico} alt="Érico Ramos" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Érico Ramos</h2>
          <h3 className="team-title">Sócio Minoritário</h3>
          <p className="team-description">
            Atuou como consultor na Accenture, Google e Nokia.
          </p>
        </div>
      </div>
      <div className="team-cardx">
        <div className="profile-image-container">
          <img src={malte} alt="Malte Niebelschuetz" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Malte Niebelschuetz</h2>
          <h3 className="team-title">Diretor comercial - EUA</h3>
          <p className="team-description">
            Trabalhou como gestor de projetos na Deutsche Telekom e hoje possui negócios em San Diego.
          </p>
        </div>
      </div>
      <div className="team-cardx">
        <div className="profile-image-container">
          <img src={ricardo} alt="Ricardo Aquino" className="profile-image" />
        </div>
        <div className="team-info">
          <h2 className="team-name">Ricardo Aquino</h2>
          <h3 className="team-title">CMO</h3>
          <p className="team-description">
            Contribuiu para marcas como Petrobras, Ponto Frio, Grupo Pão de Açúcar entre outras.
          </p>
        </div>
      </div>
    </div>
            <div className="shade2" style={{ backgroundImage: `url(${vector6})` }}>
            </div>
            <div className="midias">           
                <img className="midias" src={midias} height="24" width="260" alt="mídias" title="mídias"/>
            </div>
            <footer>
                <div className="footer-content">
                    <p>Termos de Serviço | Política de Privacidade</p> 
                </div>
                <div className="footer-copyright">
                &copy; 2024 Sobr Inc., Todos os Direitos Reservados     
                </div>
                {/* Ícone da seta para rolar até o menu principal */}
                <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                    <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top"/>
                </div>
            </footer>

</>)
    }
export default TeamSobr;

